import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';

// Firebase configuration for different environments
// Note: You'll need to get the correct config from Firebase Console for entralpi-747c9
const firebaseConfigs = {
  production: {
    apiKey: "AIzaSyCgxGwONJhBjOmz-xtaKgdMG7iR8ZPUrno",
    authDomain: "entralpi-747c9.firebaseapp.com",
    databaseURL: "https://entralpi-747c9-default-rtdb.firebaseio.com",
    projectId: "entralpi-747c9",
    storageBucket: "entralpi-747c9.firebasestorage.app",
    messagingSenderId: "2518752978",
    appId: "1:2518752978:web:6a0ee1265a04407eb4970b",
    measurementId: "G-C32ZWN87F6"
  },
  staging: {
    apiKey: "AIzaSyCgxGwONJhBjOmz-xtaKgdMG7iR8ZPUrno",
    authDomain: "entralpi-747c9.firebaseapp.com",
    databaseURL: "https://entralpi-747c9-default-rtdb.firebaseio.com", 
    projectId: "entralpi-747c9",
    storageBucket: "entralpi-747c9.firebasestorage.app",
    messagingSenderId: "2518752978",
    appId: "1:2518752978:web:6a0ee1265a04407eb4970b",
    measurementId: "G-C32ZWN87F6"
  },
  development: {
    apiKey: "AIzaSyCgxGwONJhBjOmz-xtaKgdMG7iR8ZPUrno",
    authDomain: "entralpi-747c9.firebaseapp.com",
    databaseURL: "https://entralpi-747c9-default-rtdb.firebaseio.com",
    projectId: "entralpi-747c9",
    storageBucket: "entralpi-747c9.firebasestorage.app",
    messagingSenderId: "2518752978",
    appId: "1:2518752978:web:6a0ee1265a04407eb4970b",
    measurementId: "G-C32ZWN87F6"
  }
};

// Get environment-specific config
function getFirebaseConfig() {
  const environment = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'development';
  return firebaseConfigs[environment as keyof typeof firebaseConfigs] || firebaseConfigs.development;
}

// Initialize Firebase
let firebaseApp: any;

export function initializeFirebase(): any {
  if (!firebaseApp) {
    const config = getFirebaseConfig();
    
    try {
      // Check if Firebase is already initialized
      if (getApps().length === 0) {
        firebaseApp = initializeApp(config);
      } else {
        firebaseApp = getApp();
      }
      
      // Initialize analytics and performance monitoring only in production
      if (process.env.NODE_ENV === 'production') {
        try {
          // Initialize analytics
          getAnalytics(firebaseApp);
        } catch (error) {
          console.warn('Analytics not supported in this environment:', error);
        }
        
        try {
          // Initialize performance
          getPerformance(firebaseApp);
        } catch (error) {
          console.warn('Performance monitoring not supported in this environment:', error);
        }
      }
      
      console.log('Firebase initialized successfully');
    } catch (error) {
      console.error('Error initializing Firebase:', error);
      throw error;
    }
  }
  
  return firebaseApp;
}

// Export Firebase instance and auth
export const getFirebaseApp = (): any => {
  if (!firebaseApp) {
    return initializeFirebase();
  }
  return firebaseApp;
};

export const getFirebaseAuth = (): any => {
  return getAuth(getFirebaseApp());
};

// Export the config for backward compatibility
export const firebaseConfig = getFirebaseConfig();

// Export Firebase modules for backward compatibility
export { getAuth, getAnalytics, getPerformance };
export default { getAuth, getAnalytics, getPerformance, initializeApp };
